/**
 * @file ページ遷移履歴を管理するReact Context
 *
 * 直前に訪れたページパスを保持し、戻るボタンの遷移先判定などに利用する。
 * デフォルト値は空文字列2要素（前回・前々回）の配列。
 */
import { createContext } from 'react';

/** ページ遷移履歴コンテキスト（[直前のパス, その前のパス]を保持） */
const historyContext = createContext<string[]>(['', '']);

export default historyContext;
